import  {GET_ESSEARCH,LOAD_CLASSIFIERSTEP_CADOCFORM_EP,LOAD_MON_MONFORM,LOAD_MONITORS_MONITORFORM,CHANGE_DISPLAY_LINECHART,SHOW_CHARTTYPE,SHOW_DOUGHNUTCHART,SHOW_LINECHART,LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,SHOW_MODAL_BA,HIDE_MODAL_BA,LOAD_SVSTRANDS_DYNA,LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,LOAD_CLASSIFIERSTEP_CSTEPFORM_EP,LOAD_CLASSIFIERSTEP_CSTEPFORM,LOAD_CLASSIFIER_FORM,COUNTER_ACTION,CREATE_FLOW,CREATE_STEP,CREATE_ACTION,DELETE_TASK,ADD_USER,REMOVE_USER,RESET_USER_FORM,UPDATE_USER_FORM,FETCH_MOVIES,FETCH_MOVIE,FETCH_USER,FETCH_USERS,GET_EP,GET_TASK,LIST_TASKS, LOAD_GENE_UI_DATA_CSTEPFORM_BUS, LIST_SOJOURNS, LOAD_FORM_PC_BUS, LOAD_FORM_FPC_BUS, LOAD_FORM_PD_BUS, LOAD_FORM_AD_BUS} from './constants'
import {LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS_SH, LOAD_FORM_PC_BUS_SH} from './constants'
import {UPDATE_FORM, RESET_FORM} from './redux/Actions/actionTypes'
import {getPortKey, portTypes, getPortValue} from './components/core/feeder'
// type:'classifier/LOAD_CLASSIFIER_FORM'

const _ = require('lodash')

export const loadMonform = ()=>{
    let action ={
        id:-1,
        type:LOAD_MON_MONFORM
    }

    return action
}

export const loadMonitorform = ()=>{
    let action ={
        id:-1,
        type:LOAD_MONITORS_MONITORFORM
    }

    return action
}
export const updateUserFormActionCreator=(payload)=>
({
    type:UPDATE_FORM,
    payload
})

export const resetUserFormActionCreator=(payload)=>
({
    type:RESET_FORM,
    payload
})

export const addUser = (name, company, email) =>
    ({
        type: ADD_USER,
        //id: v4(),
        name,
        company,
       email
    })

export const removeUser = id =>
({
        type: REMOVE_USER,
        id
    })


  export const  fetchUsersActionCreator=(users)=>({
        type:FETCH_USERS,
        users
    })

  export const  fetchUserActionCreator=(index)=>({
        type:FETCH_USER,
        index
    })

export const fetchEndpoints= (taskId)=>{
     let action = {
      id:taskId,
      type:GET_EP
    }
    return action

}
export const fetchTasksActionCreator= (tasks)=>{
      var oa = { type:LIST_TASKS, 
      tasks:tasks

     }
        console.log(oa);
     return oa

}

export const fetchSVESSearchActionCreator = (sojourns)=>{
    var oa = { 
        type:LIST_SOJOURNS, 
        sojourns:sojourns
  
       }
          console.log(oa);
       return oa

}

export const fetchTaskActionCreator= (idx)=>{
    var oTask = { type:GET_TASK, idx:idx}
     
     return oTask
}

export const fetchESSearchActionCreator= (idx)=>{
    var oTask = { type:GET_ESSEARCH, idx:idx}
     
     return oTask
}
export const deleteTaskActionCreator= (id)=>{

    var action={id:id, type:DELETE_TASK}
    return action
}

export const createTaskActionCreator=()=>{
    var action = {
       id:-1,
        type:CREATE_ACTION
    }
    return action

}
export const loadStepData=(data)=>{
    console.log('action CREATE_STEP')
    var action = {
       id:-1,
        type:CREATE_STEP,
        payload:{my_account_data:data}
    }
    console.log(action)
    return action

}

export const loadFlowData=()=>{
    console.log('action CREATE_STEP')
    var action = {
       id:-1,
        type:CREATE_FLOW
    }
    console.log(action)
    return action


}


export const resetTaskActionForm=(id)=>{
    var action = {
       id:id,
        type:CREATE_ACTION
    }
    return action

}

export const  fetchCounterActionCreator=()=>{
    console.log('sv moveUp')
    var action={
        id:3,
        direction:'up',
        type:COUNTER_ACTION
    }
    return action
}
  
export const loadClassifier = ()=>{
    let action ={
        id:-1,
        type:'classifier/LOAD_CLASSIFIER_FORM'
    }

    return action
}



export const loadCstepform = ()=>{
    let action ={
        id:-1,
        type:LOAD_CLASSIFIERSTEP_CSTEPFORM
    }

    return action
}


export const loadCstepformep = ()=>{
    let action ={
        id:-1,
        type:LOAD_CLASSIFIERSTEP_CSTEPFORM_EP
    }

    return action
}

export const loadCAdocformep = ()=>{
    let action ={
        id:-1,
        type:LOAD_CLASSIFIERSTEP_CADOCFORM_EP
    }

    return action
}



export const loadCstepformbus = (data)=>{
    console.log('action loadCstepformbus  ')
    let action ={
        id:-1,
        type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS
       // type:LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        //templateData:data
    }

    return action
}

export const loadGeneTemplate = (data)=>{
    console.log('action loadGeneTemplate  ')
    console.log(data)
   let {members} = data
   members.forEach((o, idx)=>{
       o.portType = getPortValue(o.portType)

   })
   data.members = members
    let action ={
        id:-1,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}
/*
const transformToGeneBad=(geneBA)=>{
    
    let member ={

        "firstName": "Alex",
        "lastName": "tam",
    
        "inputSchema": "",
        "inputSchemaType": "JSON",
        "inputSchemaTypes": [{
          "name": "JSON",
          "value": "JSON"
        }, {
          "name": "XML",
          "value": "XML"
        }, {
          "name": "SVG",
          "value": "SVG"
        }],
        "svfieldType": "CL_String",
        "portId": "portA",
        "portName": "portA",
        "portType": "CL_Number",
        "portInput": 10,
        "portTypes": [{
          "key": "CL_Number",
          "value": "number"
        }, {
          "key": "CL_String",
          "value": "string"
        },{
            "key":"CL_NArray",
            "value":"narray"  
         }, {
          "key": "CL_FLOW_OBJECT_SV",
          "value": "FLOW_OBJECT_SV"  
    
        }, {
          "key": "CL_Date",
          "value": "date"
    
        }],
    
        "locationId": "START",
        "locationText": "Location",
        "locationTypes": [{
          "name": "START",
          "value": "START"
        }, {
          "name": "CARRIER",
          "value": "CARRIER"
        }, {
          "name": "END",
          "value": "END"
        }],
        "tags": ["cloud", "svanalytics"],
        "hobbies": [
          "football"
        ]
    
      }
    let dataFrom ={
        id:'addLeft_step',
        inputPorts:['portA', 'portB'],
        gene:'addLeft_step',
        location:'START',
        input:{
            bindingType:'json',
            portA:{
                input:10,
                type:'number'

            },
            portB:{
                input:90,
                type:'number'

            }
        }
    }
    let geneOb = {
        members:[],
        "id": geneBA.id,
  "gene": geneBA.gene,
  "bindingAcceptorType": "pipeSeq_Gate",
  "bindingAcceptorName": "calculator_strand",
  "clubName": "calculator_strand"

    }
    geneOb.id = geneBA.id
    geneOb.name = geneBA.name
    geneOb.gene = geneBA.gene
    let inputPorts = dataFrom.inputPorts, portName = 'portA', portOb
   for(let i=0; i < inputPorts.length; i++){
     portName = inputPorts[i]
     portOb = dataFrom.input[portName]
     member.inputSchema = '';
     member.inputSchemaType =  dataFrom.input.bindingType.toLocaleUpperCase() || 'JSON'
     member.portInput = portOb.input
     members.portType= _.findWhere(portTypes, {value:portOb.type}).key
     member.portName = portName
     member.locationId = dataFrom.location  ||"START"
     geneOb.members.push(member)
   }
   return geneOb
}
*/
export const loadGeneTemplateMemory = (slotWrapper)=>{
    let data 
    if(slotWrapper.members && (slotWrapper.members.length > 0)){
        console.log('sv component has send transformed data SO NOT TRANSOFRMING FOR geneUI')
        data = slotWrapper



    }else{
        let slot = slotWrapper.slot
        //we need to transform
        console.log('action loadGeneTemplateMemory  ')
        console.log(slot)
       
        data = transformToGene(slotWrapper)

    }

  /* let {members} = data
   members.forEach((o, idx)=>{
       o.portType = getPortValue(o.portType)

   }) 
   data.members = members*/
    let action ={
        id:-1,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_GENE_UI_DATA_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}

export const hideModalAction =(data)=>{

    let modalData={
        id:-1,
        type:HIDE_MODAL_BA,
        name:'svmodalba'

    }
    return modalData
}
export const showModalAction =(data)=>{

   
    let modalData={
        id:-1,
        type:SHOW_MODAL_BA,
        currentStrandDataMemory:data,
       
        name:'svmodalba'

    }
    return modalData
}

export const showChartTypeAction =(data)=>{
    let modalData={
        id:-1,
        type:SHOW_CHARTTYPE,
        data:data,
        name:'svlinechart'

    }
    console.log('action  showChartTypeAction')
    console.log(data)
    return modalData 

}

export const changeChartTypeAction =(data)=>{
    let modalData={
        id:-1,
        type:CHANGE_DISPLAY_LINECHART,
        fromSVCOMTYPE:data.fromSVCOMTYPE,
        fromStrandName:data.strandName,
        fromStrandIdx: data.strandIdx,
        toSVCOMTYPE:data.SVCOMTYPE
       
       

    }
    return modalData 

}
export const showLineChartAction =(data)=>{
    let modalData={
        id:-1,
        type:SHOW_LINECHART,
        svconfig:data,
       
        name:'svlinechart'

    }
    return modalData 

}

export const showDoughnutChartAction =(data)=>{
    let modalData={
        id:-1,
        type:SHOW_DOUGHNUTCHART,
        svconfig:data,
       
        name:'svlinechart'

    }
    return modalData 
}

export const loadStrandAction = (data)=>{
    console.log('action loadStrandAction  ')
    console.log(data)
    let strandData = {
        id:-1,
        gene:'add_step',
    }

    strandData = data
    let action ={
        id:-1,
        
        strandData:strandData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}
/*svmay21 start*/

export const loadRcActionSH = (data)=>{
    console.log('action loadRcActionSH  ')
    console.log(data)
    let sjcrcData = {
        id:-1,
        gene:'add_step',
    }

    sjcrcData = data
    let action ={
        id:-1,
        
        sjcrcData:sjcrcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS_SH,
        templateData:data
    }

    return action
}

export const loadPdActionSH = (data)=>{
    console.log('sv OCT7 ***action.js loadPdActionSH  ')
    console.log(data)
    let sjcpdData = {
        id:-1,
        gene:'add_step',
    }

    sjcpdData = data
    let action ={
        id:-1,
        
        sjcpdData:sjcpdData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}

export const loadPcActionSH = (data)=>{
    console.log('action loadPcActionSH  ')
    console.log(data)
    let sjcpcData = {
        id:-1,
        gene:'add_step',
    }

    sjcpcData = data
    let action ={
        id:-1,
        
        sjcpcData:sjcpcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_PC_BUS_SH,
        templateData:data
    }

    return action
}

/*svmay21 end*/


export const loadRcAction = (data)=>{
    console.log('action loadStrandAction  ')
    console.log(data)
    let rcData = {
        id:-1,
        gene:'add_step',
    }

    rcData = data
    let action ={
        id:-1,
        
        rcData:rcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}


export const loadPdAction = (data)=>{
    console.log('sv OCT7 ***action.js loadPdAction  ')
    console.log(data)
    let pdData = {
        id:-1,
        gene:'add_step',
    }

    pdData = data
    let action ={
        id:-1,
        
        pdData:pdData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}

export const loadAdAction = (data)=>{
    console.log('action loadAdAction  ')
    console.log(data)
    //id:-1 to show create. edit will have positive id from db
    let adData = {
        "id":-1,
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "12 scotland av",
        "city": "Albany",
        "state": "New York",
        "zip": "12110",
        "country": "USA",
        "isdcode": "+1",
        "phone": "5121234356"
    }

    adData = data
    let action ={
        id:-1,
        
        adData:adData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_AD_BUS,
        templateData:data
    }

    return action
}


export const loadCountriesAction = (data)=>{
    console.log('action loadPcAction  ')
    console.log('sv OCT7 ***action.js  pdData changedloadCountriesAction  ')
 
    console.log(data)
    let pdData = data

   
    let action ={
        id:-1,
        
        pdData:pdData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_AD_BUS,
        templateData:data
    }

    return action
}

export const loadPdMyReservatiionsAddressAction = (data)=>{
    console.log('sv OCT7 ***action.js loadPdMyReservatiionsAddressAction  ')
    console.log(data)
    let pdData = data

   
    let action ={
        id:-1,
        
        pdData:pdData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_PD_BUS,
        templateData:data
    }

    return action
}
export const loadFpcAction = (data)=>{
    console.log('action loadPcAction  ')
    console.log(data)
    let pcData = {
        id:-1,
        gene:'add_step',
    }

    pcData = data
    let action ={
        id:-1,
        
        fpcData:pcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_FPC_BUS,
        templateData:data
    }

    return action
}
export const loadPcAction = (data)=>{
    console.log('action loadPcAction  ')
    console.log(data)
    let pcData = {
        id:-1,
        gene:'add_step',
    }

    pcData = data
    let action ={
        id:-1,
        
        pcData:pcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_PC_BUS,
        templateData:data
    }

    return action
}
export const loadStrandActionMemory = (data)=>{
    console.log('action loadStrandActionMemory shouls have ba  ')
    console.log(data)

    if( (data.gene == "Required") && (data.stype !='flow')){
        data.gene = data.bindingAcceptorParalle.bus[0].name
    }else if( (data.gene == "Required") && (data.stype =='flow')){
        data.gene = data.bindingAcceptor.bus[0].name
    }   
    let strandDataMemory = {
        id:-1,
        gene:'addLeft_step',
        "name": "strand21",
        "stype": "converge",
        "bindingAcceptorParalle": {
            "name": "paralle3Gate_strand",
            "bus": [{
                "id": "addLeft_step",
                "inputPorts": ["portA", "portB"],
                "gene": "addLeft_step",
                "location": "START",
                "input": {
                    "bindingType": "json",
                    "portA": {
                        "input": 111,
                        "type": "number"
                    },
                    "portB": {
                        "input": 112,
                        "type": "number"
                    }
                }
            }, {
    
                "id": "addRight_step",
                "inputPorts": ["portA", "portB"],
                "gene": "addRight_step",
                "location": "START",
                "input": {
                    "bindingType": "json",
                    "portA": {
                        "input": 211,
                        "type": "number"
                    },
                    "portB": {
                        "input": 212,
                        "type": "number"
                    }
                }
            }, {
                "id": "multiply_step",
                "inputPorts": ["portA", "portB"],
                "gene": "multiply_step",
                "location": "CARRIER",
                "input": {
                    "bindingType": "json",
                    "portA": {
    
                        "input": {
                            "gene": "addLeft_step",
                            "portRef": "outA",
                            "type": "number"
                        },
                        "type": "FLOW_OBJECT_SV"
                    },
                    "portB": {
                        "input": {
                            "gene": "addRight_step",
                            "portRef": "outA",
                            "type": "number"
                        },
                        "type": "FLOW_OBJECT_SV"
                    }
                }
            }]
    
        },
        "status": "incomplete"
    }

    strandDataMemory = data
    let currentGenes
  if(data.stype !='flow'){
     currentGenes = svGenesOfStrand(data.bindingAcceptorParalle, data.name)

  }else{
    currentGenes = svGenesOfStrand(data.bindingAcceptor, data.name)

  }
   
    console.log('---currentGenes')
    console.log(currentGenes)
    strandDataMemory.currentGenes = currentGenes
   
   // strandData = data
    let action ={
        id:-1,
        
        strandDataMemory:strandDataMemory,
        currentGenes:currentGenes,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,
        templateData:data
    }

    return action
}


export const loadSVStrandsDyna=(strands)=>{
    console.log('action +++loadSVStrandsDyna ')
    let o ={
        type:LOAD_SVSTRANDS_DYNA,
        id:-1,
        strandsDynaData: { strands:strands} 
    }
    console.log(o)
    return o

}

const transformToGene=(slotWrapper)=>{
    let geneBA = slotWrapper.slot
    
    let member ={

        "firstName": "Alex",
        "lastName": "tam",
    
        "inputSchema": "",
        "inputSchemaType": "JSON",
        "inputSchemaTypes": [{
          "name": "JSON",
          "value": "JSON"
        }, {
          "name": "XML",
          "value": "XML"
        }, {
          "name": "SVG",
          "value": "SVG"
        }],
        "svfieldType": "CL_String",
        "portId": "portA",
        "portName": "portA",
        "portType": "CL_Number",
        "portInput": 10,
        "portTypes": [{
          "key": "CL_Number",
          "value": "number"
        }, {
          "key": "CL_String",
          "value": "string"
        },{
            "key":"CL_NArray",
            "value":"narray"   
         }, {
          "key": "CL_FLOW_OBJECT_SV",
          "value": "FLOW_OBJECT_SV"  
    
        }, {
          "key": "CL_Date",
          "value": "date"
    
        }],
    
        "locationId": "START",
        "locationText": "Location",
        "locationTypes": [{
          "name": "START",
          "value": "START"
        }, {
          "name": "CARRIER",
          "value": "CARRIER"
        }, {
          "name": "END",
          "value": "END"
        }],
        "tags": ["cloud", "svanalytics"],
        "hobbies": [
          "football"
        ]
    
      }
    let dataFrom ={
        id:'addLeft_step',
        inputPorts:['portA', 'portB'],
        gene:'addLeft_step',
        location:'START',
        input:{
            bindingType:'json',
            portA:{
                input:10,
                type:'number'

            },
            portB:{
                input:90,
                type:'number'

            }
        }
    }
    let geneOb = {
        members:[],
      //  "id": geneBA.id || -1,
  //"gene": geneBA.gene || 'addLeft_step',
  "id": -1,
  "gene":  'addLeft_step',
  "bindingAcceptorType": "pipeSeq_Gate",
  "bindingAcceptorName": "calculator_strand",
  "clubName": "calculator_strand"

    }
    geneOb.id = geneBA.id
    geneOb.name = geneBA.name
    geneOb.gene = geneBA.gene
    geneOb.bindingAcceptorType= slotWrapper.bindingAcceptorType
    geneOb.bindingAcceptorName =slotWrapper.bindingAcceptorName
    geneOb.clubName = slotWrapper.clubName
    
    let inputPorts = geneBA.inputPorts, portName = 'portA', portOb
   for(let i=0; i < inputPorts.length; i++){
     portName = inputPorts[i]
     portOb = geneBA.input[portName]
     member = _.clone(member)
     member.inputSchema = ''
     member.inputSchemaType =  geneBA.input.bindingType.toLocaleUpperCase() || 'JSON'
     
     member.portType = portOb.type
     if(portOb.type ==='FLOW_OBJECT_SV'){
         //sv we need tp diable port
        member.portInput = -100
        member.portType = 'FLOW_OBJECT_SV'

     }else{
        member.portInput = portOb.input

     }
     
    // member.portType= _.findWhere(portTypes, {value:portOb.type}).key
     member.portName = portName
     member.locationId = geneBA.location  ||"START"
     geneOb.members.push(member)
   }
   return geneOb
}


const svGenesOfStrand=(bindingAcceptorParalle, strandName)=>{
           
    console.log('svAllload:' + strandName)
   // this.bindingAcceptor = bindingAcceptorParalle
         let   genes= []
            for(let i=0; i < bindingAcceptorParalle.bus.length ; i++){
                genes.push({
                 name:bindingAcceptorParalle.bus[i].gene,
                 value:bindingAcceptorParalle.bus[i].gene
                   }  )  

            }
            console.log('sv dyna genes+++++++++++++++++++++++++++++++++++++++++++++++++++')
            console.log(genes)
      return genes     

}